import { useIntl } from "react-intl";
import Badge from "components/v2/Badge/Badge";

export default function SelectPaymentLocationBadge() {
  const intl = useIntl();
  return (
    <Badge
      type="category-badge"
      size="sm"
      color="warning"
      label={intl.formatMessage({
        id: "request-form.selectPaymentLocation",
        defaultMessage: "Select payment location",
      })}
    />
  );
}
